import Viewport from 'pixi-viewport';

import { app } from '../../../index';
import { IScrollViewItem } from './IScrollViewItem';

export class ScrollView extends PIXI.Container {
    public readonly itemsContainer: PIXI.Container;
    public readonly scrollView: Viewport;
    protected items: IScrollViewItem[] = [];
    protected screenHeight: number;
    private adjustX: boolean;
    private adjustY: boolean;

    constructor(
        width: number,
        height: number,
        parentContainer: PIXI.Container,
        adjustX?: boolean,
        adjustY?: boolean
    ) {
        super();
        this.adjustX = adjustX;
        this.adjustY = adjustY;
        const scrollView = (this.scrollView = new Viewport({
            screenWidth: width,
            screenHeight: height,
            interaction: app.renderer.plugins.interaction,
        }));

        scrollView.drag().decelerate();
        scrollView.clamp({
            direction: 'all',
        });

        scrollView.on('drag-start', () => this.setDragging(true));
        scrollView.on('drag-end', () => this.setDragging(false));

        this.itemsContainer = new PIXI.Container();
        const mask = new PIXI.Graphics();
        mask.beginFill(0x000000);
        mask.drawRoundedRect(0, 0, width, height, 10);
        this.itemsContainer.mask = mask;
        this.screenHeight = height;
        scrollView.addChild(this.itemsContainer);
        this.addChild(scrollView);
        //@ts-ignore
        parentContainer.addChild(this, mask);
    }

    public addItem(item: IScrollViewItem) {
        this.itemsContainer.addChild(item);
        this.items.push(item);
        this.fitContent();
    }

    public fitContent() {
        const { scrollView, itemsContainer } = this;
        const { screenHeight, screenWidth } = scrollView;
        const pivotX =
            this.adjustX && itemsContainer.width < screenWidth
                ? (screenWidth - itemsContainer.width) / 2
                : itemsContainer.pivot.x;
        const pivotY =
            this.adjustY && itemsContainer.height < screenHeight
                ? (screenHeight - itemsContainer.height) / 2
                : itemsContainer.pivot.y;

        itemsContainer.pivot.set(pivotX, pivotY);

        this.scrollView.resize(
            this.scrollView.screenWidth,
            this.screenHeight,
            this.itemsContainer.width,
            this.itemsContainer.height + (this.adjustY ? 20 : 5)
        );
    }

    public setDragging(dragging: boolean) {
        this.items.forEach(element => {
            element.setDragging(dragging);
        });
    }
}
